export enum Cookies {
  CART_ID = 'cart-id',
  DESIGN_SERVICE = 'design-service',
  USER_INFOS = 'user-infos',
  CURRENCY = 'currency'
}
